<template>
	<button @click="addToCart" v-if="hasPrice" class="prodcard__addtocart" title="Добавить в корзину">
		<img :src="url + '/assets/img/ico-cartprod.svg'" alt=""></button>
</template>

<script>
  import { bus } from './bus.js'
  import { product } from "../mixins/product";

  export default {
    name: "product-component",
	  mixins: [product],
    data() {
      return {

      }
    },
    props: {
      item: '',
      url: ''
    },
    methods: {
      addToCart() {
        let app = this;
        let item = this.item;
        let currentProp;
        if(this.checkPrice()){
          currentProp = this.checkPrice();
        } else {
          currentProp = this.item.props[0];
        }
        let count = 1;
        let total = currentProp.price * count;

        item.currentProp = currentProp;
        item.count = count;
        item.total = total;


        let fd = {
          item
        };

        console.log(fd);
        $.request('onAddtoCart', {
          data: fd,
          success: function (data) {
            //... do something ...
            console.log(data);
            app.notify();
            bus.$emit('cart-reload', data.cart);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
      }
    },
    mounted() {
      this.checkHasPrice();
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/lent-prod.vue